module.exports = __webpack_public_path__ + "static/media/code-window.4abaac44.svg";